

// export default CreateTasksAdmin;
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDesignations,
  fetchLocations,
  fetchTasksList,
  fetchEmployees,
  createTaskSubmit
} from "../redux/actions/CreateTasksAdminActions";
import { inputStyle, labelStyle, buttonStyle, errorStyle } from "../components/shared/themeStyles";

const CreateTasksAdmin = () => {
  const dispatch = useDispatch();
  const {
    designations,
    locations,
    tasksList,
    employeesByDesignation,
    loading,
    error,
    success
  } = useSelector(state => state.taskAdmin);

  const [tasks, setTasks] = useState([
    {
      designation: "",
      employees: [],
      user_id: "",
      task_name: "",
      start_time: "",
      end_time: "",
      location_id: "",
      other_location: "",
      remarks: "",
      createTaskDate: "",
      endTaskDate: ""
    }
  ]);

  // Fetch dropdown data
  useEffect(() => {
    dispatch(fetchDesignations());
    dispatch(fetchLocations());
    dispatch(fetchTasksList());
  }, [dispatch]);

  // Reset form on success
  useEffect(() => {
    if (success) {
      setTasks([
        {
          designation: "",
          employees: [],
          user_id: "",
          task_name: "",
          start_time: "",
          end_time: "",
          location_id: "",
          other_location: "",
          remarks: "",
          createTaskDate: "",
          endTaskDate: ""
        }
      ]);
    }
  }, [success]);

  const handleChange = (index, field, value) => {
    const updated = [...tasks];
    updated[index][field] = value;

    if (field === "designation") {
      updated[index].user_id = "";
      const empList = employeesByDesignation[value] || [];
      updated[index].employees = empList;
      setTasks(updated);

      if (!empList.length && value) dispatch(fetchEmployees(value));
    } else {
      setTasks(updated);
    }
  };

  const addTask = () =>
    setTasks([
      ...tasks,
      {
        designation: "",
        employees: [],
        user_id: "",
        task_name: "",
        start_time: "",
        end_time: "",
        location_id: "",
        other_location: "",
        remarks: "",
        createTaskDate: "",
        endTaskDate: ""
      }
    ]);

  const removeTask = (index) => setTasks(tasks.filter((_, i) => i !== index));

  const handleSubmit = (e) => {
    e.preventDefault();
    const now = new Date();
    const autoDate = now.toISOString().split("T")[0];
    const autoTime = now.toTimeString().slice(0, 5);

    const payload = tasks.map(task => ({ ...task, date: autoDate, time: autoTime }));
    dispatch(createTaskSubmit(payload));
  };

  return (
    <div style={{ padding: "2rem", minHeight: "100vh", backgroundColor: "#F9FAFB" }}>
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          background: "#fff",
          padding: "2rem",
          borderRadius: "1rem",
          boxShadow: "0 4px 8px rgba(0,0,0,0.06)",
          border: "1px solid #eee"
        }}
      >
        <h1
          style={{
            fontSize: "1.875rem",
            fontWeight: 700,
            marginBottom: "1rem",
            color: "#1F2937"
          }}
        >
          Create Tasks
        </h1>

        {error && <div style={errorStyle}>❌ {error}</div>}
        {success && (
          <div
            style={{
              background: "#DCFCE7",
              color: "#166534",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              marginBottom: "1rem",
              border: "1px solid #BBF7D0"
            }}
          >
            ✅ Tasks submitted successfully!
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ marginTop: "1.5rem" }}>
          {tasks.map((task, index) => (
            <div
              key={`task-${index}`}
              style={{
                border: "1px solid #e5e7eb",
                background: "#F3F4F6",
                padding: "1.5rem",
                borderRadius: "0.75rem",
                marginBottom: "1.5rem"
              }}
            >
              <div
                style={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}
              >
                <h2 style={{ fontSize: "1.25rem", fontWeight: 600, color: "#374151" }}>
                  Task #{index + 1}
                </h2>
                {tasks.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeTask(index)}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#EF4444",
                      fontWeight: 600,
                      cursor: "pointer",
                      fontSize: "1rem"
                    }}
                  >
                    ✖ Remove
                  </button>
                )}
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: "1.2rem"
                }}
              >
                {/* Designation */}
                <div>
                  <label style={labelStyle}>Designation</label>
                  <select
                    style={inputStyle}
                    value={task.designation}
                    onChange={(e) => handleChange(index, "designation", e.target.value)}
                  >
                    <option value="">Select Designation</option>
                    {designations.map((des, i) => (
                      <option key={i} value={des}>
                        {des}
                      </option>
                    ))}
                  </select>
                </div>

                {/* User */}
                <div>
                  <label style={labelStyle}>User</label>
                  <select
                    style={inputStyle}
                    value={task.user_id || ""}
                    onChange={(e) => handleChange(index, "user_id", Number(e.target.value))}
                    required
                  >
                    <option value="">Select User</option>
                    {(employeesByDesignation[task.designation] || []).map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.name} ({emp.phone})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Task Name */}
                <div>
                  <label style={labelStyle}>Task Name</label>
                  <input
                    type="text"
                    style={inputStyle}
                    value={task.task_name}
                    onChange={(e) => handleChange(index, "task_name", e.target.value)}
                    placeholder="Enter task name"
                    required
                  />
                </div>

                {/* Other Location */}
                <div>
                  <label style={labelStyle}>Visit Location</label>
                  <select
                    style={inputStyle}
                    value={task.other_location || ""}
                    onChange={(e) => handleChange(index, "other_location", Number(e.target.value))}
                  >
                    <option value="">Select Location</option>
                    {locations.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.location_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Task Purpose */}
                <div>
                  <label style={labelStyle}>Visit Purpose</label>
                  <select
                    style={inputStyle}
                    value={task.location_id || ""}
                    onChange={(e) => handleChange(index, "location_id", Number(e.target.value))}
                    required
                  >
                    <option value="">Select purpose</option>
                    {tasksList.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.title}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Start Date & Time */}
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>Start Date</label>
                    <input
                      type="date"
                      style={inputStyle}
                      value={task.createTaskDate}
                      onChange={(e) => handleChange(index, "createTaskDate", e.target.value)}
                      required
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>Start Time</label>
                    <input
                      type="time"
                      style={inputStyle}
                      value={task.start_time}
                      onChange={(e) => handleChange(index, "start_time", e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* End Date & Time */}
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>End Date</label>
                    <input
                      type="date"
                      style={inputStyle}
                      value={task.endTaskDate}
                      onChange={(e) => handleChange(index, "endTaskDate", e.target.value)}
                      required
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>End Time</label>
                    <input
                      type="time"
                      style={inputStyle}
                      value={task.end_time}
                      onChange={(e) => handleChange(index, "end_time", e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* Remarks */}
                <div style={{ gridColumn: "1 / -1" }}>
                  <label style={labelStyle}>Remarks</label>
                  <textarea
                    style={{ ...inputStyle, height: "80px" }}
                    value={task.remarks}
                    onChange={(e) => handleChange(index, "remarks", e.target.value)}
                  />
                </div>
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={addTask}
            style={{ ...buttonStyle, width: "100%", background: "#4B5563", marginBottom: "1rem" }}
          >
            + Add Another Task
          </button>

          <button
            type="submit"
            disabled={loading}
            style={{ ...buttonStyle, width: "100%", background: loading ? "#9CA3AF" : "#6366F1" }}
          >
            {loading ? "Submitting..." : "Submit Tasks"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateTasksAdmin;
